import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
type CTATone = 'fire' | 'call' | 'whatsapp';
interface CTAButtonProps extends Omit<ButtonProps, 'variant'> {
  children: React.ReactNode;
  href?: string;
  tone?: CTATone;
}
export function CTAButton({
  children,
  href,
  tone = 'fire',
  ...props
}: CTAButtonProps) {
  const handleClick = () => {
    if (!href) return;
    if (href.startsWith('tel:')) {
      window.location.href = href;
      return;
    }
    window.open(href, '_blank', 'noopener,noreferrer');
  };
  const toneStyles: Record<string, ButtonProps> = {
    fire: {
      className: 'fire-gradient fire-glow',
      color: 'white',
      _hover: {
        filter: 'brightness(1.12)',
        transform: 'translate3d(0, -2px, 0)'
      }
    },
    call: {
      bg: 'call.500',
      color: 'white',
      boxShadow: '0 6px 24px rgba(45, 111, 224, 0.32)',
      _hover: {
        bg: 'call.400',
        transform: 'translate3d(0, -2px, 0)'
      }
    },
    whatsapp: {
      bg: '#25D366',
      color: 'white',
      boxShadow: '0 6px 24px rgba(37, 211, 102, 0.3)',
      _hover: {
        bg: '#20BA5A',
        transform: 'translate3d(0, -2px, 0)'
      }
    }
  };
  return <Button onClick={handleClick} size="lg" fontSize={{
    base: 'sm',
    md: 'md'
  }} fontWeight="bold" textTransform="uppercase" letterSpacing="wide" px={8} py={7} height="auto" whiteSpace="normal" lineHeight="1.35" borderRadius="lg"
  /* Short, transform-only transition so taps feel immediate. */ transition="transform 0.15s ease, filter 0.15s ease, background-color 0.15s ease" _active={{
    transform: 'scale(0.98)'
  }} {...toneStyles[tone]} {...props} data-id="element-1" data-mp="1i8jjpoiy0buh">
      {children}
    </Button>;
}